import { I18n } from '@calendly/i18n'
import { Loader } from '@calendly/ui/components/loader'
import { useEffect, useRef, useState } from 'react'
import { Redirect, useParams } from 'react-router-dom'

import { useGetUserQuery } from 'common'

import { useGetAvailabilitySchedulesQuery } from '../api'
import { Header } from './header'
import { Schedules } from './schedules'
import { TabPage } from '../components/tab_page'
import { SCHEDULES_PATH } from '../constants'

export const SchedulesTab = ({ currentScheduleId, currentEventType, trackLocation, onClose }) => {
  const formInnerRef = useRef(null)
  const formContentRef = useRef(null)
  const [isFormDirty, setIsFormDirty] = useState(false)
  const { data: { primary_availability_rule_id: defaultScheduleId } } = useGetUserQuery()
  const { data, isLoading, isFetching, isError, refetch } = useGetAvailabilitySchedulesQuery()
  const { id } = useParams()

  useEffect(() => {
    refetch()
  }, [refetch])

  if (isError || !data) return null
  if (isLoading) return <Loader />

  const selectedScheduleId = Number(currentScheduleId || id || defaultScheduleId)
  const allSchedules = data || []
  const selectedSchedule = allSchedules.find(({ id: scheduleId }) => scheduleId === selectedScheduleId)

  if (!selectedSchedule) {
    return isFetching
      ? <Loader />
      : <Redirect to={SCHEDULES_PATH} />
  }

  return (
    <TabPage
      ref={formContentRef}
      pageTitle={I18n.t('publisher.event_type_editor.sections.available_hours.schedules_label')}
      header={(
        <Header
          isFormDirty={isFormDirty}
          selectedScheduleId={selectedScheduleId}
          currentEventType={currentEventType}
          trackLocation={trackLocation}
          onClose={onClose}
        />
      )}
      withinModal={Boolean(onClose)}
    >
      <Schedules
        formInnerRef={formInnerRef}
        formContentRef={formContentRef}
        setIsFormDirty={setIsFormDirty}
        selectedScheduleId={selectedScheduleId}
        currentEventType={currentEventType}
        trackLocation={trackLocation}
        onClose={onClose}
      />
    </TabPage>
  )
}
